import React from 'react';
import {Route, Router, Switch} from 'react-router-dom';
import {Calendar} from './Calendar';
import {myHistory} from "./index";

export default function App() {

    return (
        <Router history={myHistory}>
            <Switch>
              <Route path="/s/:uri" component={Calendar}/>
            </Switch>
        </Router>
    );
}
